module.exports = __webpack_public_path__ + "img/preview.d374bc3a.webp";